import React, { useState, useCallback } from 'react'

import { ProgressBar, Alert } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone'

import ExcelIcon from './../.../../../../assets/img/excel.png'
import axios from './../../../services/Api'

import { FaCheckCircle } from 'react-icons/fa'
import { AiFillWarning } from 'react-icons/ai'

import './index.css'

function UploadExcelForm() {
    const [isUploading, setIsUploading] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [progress, setProgress] = useState(0);
    const [showFeedback, setShowFeedback] = useState(false);
    const [feedbackData, setFeedbackData] = useState({});

    const onDrop = useCallback(acceptedFiles => {
        if (acceptedFiles[0] != null)
            upload(acceptedFiles[0])
    }, [])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', maxFiles: 1, onDrop })

    const upload = async (file) => {
        setShowMessage(false);
        setIsUploading(true);
        const config = {
            onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                setProgress(percentCompleted);
            }
        }

        let data = new FormData()
        data.append('file', file)
        try {
            const response = await axios.post('/api/reports/generate-reports-by-excel', data, config)
            setIsUploading(false);
            setProgress(0);
            console.log(response.data);
            setFeedbackData(response.data);
            setShowFeedback(true);
        } catch (e) {
            const message = e.response ? e.response.data.error : e.message;
            setIsUploading(false);
            setProgress(0);
        }
    }

    return (
        <div className="UploadExcelForm">
            {showFeedback ? feedback() : dropzone()}
        </div>
    );


    function dropzone() {
        return (
            <div className="dropzone" {...getRootProps()}>
                <img src={ExcelIcon} width="150" />
                <h1>Enviar modelo excel</h1>
                <h3>Clique para selecionar o arquivo ou o arraste para cá</h3>
                <input {...getInputProps()} />
                {isUploading && <ProgressBar variant="success" now={progress} label={`${progress}%`} />}

                {showMessage && feedback()}
            </div>
        )
    }

    function feedback() {
        return (
            <div>
                <Alert variant="success">
                    <div className="message">
                        <FaCheckCircle /> {`${feedbackData.reportsToProccess} registro(s) foram lido(s) e encaminhado(s) para processamento com sucesso!`}
                    </div>
                </Alert>
                {
                    feedbackData.errors.length > 0 && (
                        <Alert variant="warning">
                            <div className="message">
                                <AiFillWarning /> {`${feedbackData.errors.length} erro(s) foram gerado(s) na leitura do arquivo!`}
                            </div>
                            <ul style={{ padding: 20 }}>
                                {
                                    feedbackData.errors.map((error, key) => (<li key={key}>{error}</li>))
                                }
                            </ul>
                        </Alert>
                    )
                }
            </div>
        )
    }
}

export default UploadExcelForm